<template>
  <div>
    <Multiselect
      v-model="valueObject"
      :options="filteredOptions"
      :label="$attrs.label"
      :trackBy="$attrs.trackBy"
      :multiple="max > 1 || max < 0"
      :internalSearch="false"
      :max="max === 1 ? false : max > 1 ? max : 99999"
      :closeOnSelect="max === 1"
      :preselectFirst="false"
      :placeholder="placeholderLabel"
      :class="['asd-multiselect']"
      :allowEmpty="allowEmpty"
      :disabled="disabled"
      selectLabel="Vyberte zmáčknutím enteru"
      selectGroupLabel="Vyberte skupinu zmáčknutím enteru"
      selectedLabel="Vybráno"
      deselectLabel="Odeberte zmáčknutím enteru"
      deselectGroupLabel="Odeberte skupinu zmáčknutím enteru"
      @search-change="searchChange"
    >
      <template v-slot:maxElements>
        Byl vybrán maximální počet vybraných položek.
      </template>

      <template v-slot:noResult>
        Žádná položka neodpovída vyhledávání.
      </template>

      <template v-slot:noOptions>
        List je prázdný.
      </template>

      <template v-if="afterList.length"
                slot="afterList"
      >
        <li class="multiselect__element"
            @click="afterList[1]"
        >
          <span class="multiselect__option asd-multiselect__more-options">
            {{ afterList[0] }}
          </span>
        </li>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
    name: 'VueMultiselectExt',
    components: {
        Multiselect,
    },
    props: {
        valueByPath: {
            type: [String, Boolean],
            required: false,
            default: _ => false,
        },
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: [Array, String, Number],
            required: false,
            default: _ => [],
        },
        max: {
            type: Number,
            required: false,
            default: _ => 1,
        },
        returnAsSingle: {
            type: Boolean,
            required: false,
            default: _ => false,
        },
        allowEmpty: {
            type: Boolean,
            required: false,
            default: _ => true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: _ => false,
        },
        afterList: {
            type: Array,
            required: false,
            default: _ => [],
        },
        placeholder: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data() {
        return {
            searchFilter: false,
        }
    },
    computed: {
        valueObject: {
            get() {
                if (this.returnAsSingle) {
                    if (this.valueByPath !== false) {
                        return _.find(this.options, o => _.get(o, this.valueByPath) === this.value)
                    } else {
                        return this.value
                    }
                } else {
                    if (this.valueByPath !== false) {
                        return _.filter(this.options, o => _.indexOf(this.value, _.get(o, this.valueByPath)) >= 0)
                    } else {
                        return this.value
                    }
                }
            },
            set(value) {
                if (this.valueByPath !== false) {
                    if (this.max === 1) {
                        if (this.returnAsSingle) {
                            this.$emit('input', _.get(value, this.valueByPath))
                        } else {
                            if (_.get(value, this.valueByPath, false)) {
                                this.$emit('input', [_.get(value, this.valueByPath)])
                            } else {
                                this.$emit('input', [])
                            }
                        }
                    } else if (this.max > 1 || this.max < 0) {
                        this.$emit('input', _.map(value, v => _.get(v, this.valueByPath)))
                    } else {
                        console.error(`Chybna hodnota max = ${this.max}`)
                    }
                } else {
                    return this.$emit('input', value)
                }
            },
        },
        filteredOptions() {
            if (this.searchFilter) {
                return _.filter(this.options, v => {
                    const fieldValue = _.lowerCase(_.deburr(_.get(v, this.$attrs.label, '')))
                    const found = fieldValue.search(this.searchFilter)
                    return found >= 0
                }).slice().sort(czSorter(this.$attrs.label, 'ASC'))
            } else {
                return this.options.slice().sort(czSorter(this.$attrs.label, 'ASC'))
            }
        },
        placeholderLabel() {
            if (this.placeholder === null) {
                if (this.max < 0) {
                    return `Vyberte více`
                }

                if (this.max === 1) {
                    return `Vyberte`
                }

                if (this.max > 1) {
                    return `Vyberte maximálně ${this.max}`
                }
            }
            return this.placeholder
        },
    },
    methods: {
        searchChange(searchQuery, id) {
            if (_.size(searchQuery) > 0) {
                this.searchFilter = _.lowerCase(_.deburr(searchQuery))
            } else {
                this.searchFilter = false
            }
        },
    },
}

const czSorter = (property, direction) => (a, b) => {
    const stringA = _.get(a, property, '')
    const stringB = _.get(b, property, '')
    const comp = stringA.localeCompare(stringB, 'cs')
    return comp
}
</script>

<style lang="scss">
@import '~vue-multiselect/dist/vue-multiselect.min.css';

.asd-multiselect {
    .multiselect__tags {
        border: 1px solid var(--color-input-border);
        border-radius: 3px;
        min-height: 2.5rem;
        font-size: 1rem;
        padding: 0;
        background-color: transparent;
    }
    .multiselect__single, .multiselect__placeholder, .multiselect__input {
        margin: 0.75rem;
        padding: 0;
        line-height: 1rem;
        height: 1rem;
        width: auto;
        min-height: 1rem;
        background-color: transparent;
    }
    .multiselect__select {
        width: 2rem;
        height: calc(2.5rem - 0px);
        &::before {
            border-color: var(--color-primary) transparent transparent;
        }
    }
    .multiselect__tags-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .multiselect__tag {
            margin: 5px;
        }
    }
    &__more-options {
        color: var(--color-primary);
        background-color: DeepSkyBlue;
        font-style: italic;
    }
}
.multiselect--disabled {
    background: rgba(0, 0, 0, 0.05);
    pointer-events: none;
    opacity: 1;
    color: gray;
    filter: grayscale(1);
    .multiselect__select {
        background-color: transparent;
        &::before {
            border-color: silver transparent transparent;
        }
    }
}
</style>
